<video autoplay controls [volume]="0.2">
  <source [src]="source" type="video/mp4" />
</video>
<div class="close-btn">
  <span nz-icon nzType="close-circle" nzTheme="twotone" (click)="close()"></span>
</div>
